import React, { useEffect, useReducer, useState, useContext } from "react";
import toastError from "../../errors/toastError";
import Popover from "@mui/material/Popover";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResponsiveSheet from "../ResponsiveSheet";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";

import {
  Avatar,
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Dialog,
  Paper,
  Box,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import api from "../../services/api";
import { isArray } from "lodash";
import moment from "moment";


function AnnouncementDialog({ announcement, open, handleClose }) {
  // const getMediaPath = (filename) => {
  //   return path.join(`${process.env.REACT_APP_BACKEND_URL}`,"public", "announcements",`${filename}`);
  // };
  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{announcement.title}</DialogTitle>
      <DialogContent>
        {announcement.mediaPath && (
          <div
            style={{
              border: "1px solid #f1f1f1",
              margin: "0 auto 20px",
              textAlign: "center",
              width: "95%",
              height: 300,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <img
              alt={`announcement image`}
              src={announcement.mediaPath}
              style={{
                width: "95%",
                height: "100%",
              }}
            />
          </div>
        )}
        <DialogContentText id="alert-dialog-description" style={{ whiteSpace: "pre-line" }}>
          {announcement.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()} color="primary" autoFocus>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_ANNOUNCEMENTS") {
    const announcements = action.payload;
    const newAnnouncements = [];

    if (isArray(announcements)) {
      announcements.forEach((announcement) => {
        const announcementIndex = state.findIndex(
          (u) => u.id === announcement.id
        );
        if (announcementIndex !== -1) {
          state[announcementIndex] = announcement;
        } else {
          newAnnouncements.push(announcement);
        }
      });
    }

    return [...state, ...newAnnouncements];
  }

  if (action.type === "UPDATE_ANNOUNCEMENTS") {
    const announcement = action.payload;
    const announcementIndex = state.findIndex((u) => u.id === announcement.id);

    if (announcementIndex !== -1) {
      state[announcementIndex] = announcement;
      return [...state];
    } else {
      return [announcement, ...state];
    }
  }

  if (action.type === "DELETE_ANNOUNCEMENT") {
    const announcementId = action.payload;

    const announcementIndex = state.findIndex((u) => u.id === announcementId);
    if (announcementIndex !== -1) {
      state.splice(announcementIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

export default function AnnouncementsPopover() {
  const theme = useTheme();
  // RDS-FIX-NOTIFICATIONS-MOBILE: mismo fix ya aplicado en
  // NotificationsPopOver -- en móvil el Popover anclado se cortaba/montaba
  // sobre el topbar (44px). Popover se mantiene igual en desktop.
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [searchParam] = useState("");
  const [announcements, dispatch] = useReducer(reducer, []);
  const [invisible, setInvisible] = useState(false);
  const [announcement, setAnnouncement] = useState({});
  const [showAnnouncementDialog, setShowAnnouncementDialog] = useState(false);
//   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchAnnouncements();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.companyId && socket) {
      const companyId = user.companyId;
//    const socket = socketManager.GetSocket();

      const onCompanyAnnouncement = (data) => {
        if (data.action === "update" || data.action === "create") {
          dispatch({ type: "UPDATE_ANNOUNCEMENTS", payload: data.record });
          setInvisible(false);
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_ANNOUNCEMENT", payload: +data.id });
        }
      };
        if (!socket) return;
      socket.on(`company-announcement`, onCompanyAnnouncement);

      return () => {
        socket.off(`company-announcement`, onCompanyAnnouncement);
      };
    }
    return undefined;
  }, [user]);

  const fetchAnnouncements = async () => {
    try {
      // Usar nova rota que filtra por empresa
      const { data } = await api.get("/announcements/for-company", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_ANNOUNCEMENTS", payload: data.records });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setInvisible(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const borderPriority = (priority) => {
    if (priority === 1) {
      return "4px solid #b81111";
    }
    if (priority === 2) {
      return "4px solid orange";
    }
    if (priority === 3) {
      return "4px solid grey";
    }
  };


  const handleShowAnnouncementDialog = (record) => {
    setAnnouncement(record);
    setShowAnnouncementDialog(true);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // RDS-FIX-NOTIFICATIONS-MOBILE: mismo contenido para las dos ramas --
  // Popover en desktop (sin cambios) y ResponsiveSheet en móvil, ver
  // abajo. Nada de lógica de datos/estado se tocó, solo el contenedor.
  const announcementListContent = (
    <Paper
      variant="outlined"
      onScroll={handleScroll}
      sx={theme => ({ flex: 1, maxHeight: 300, maxWidth: 500, padding: theme.spacing(1), overflowY: "scroll", ...theme.scrollbarStyles, borderRadius:"12px", border: theme.palette.mode==="dark" ? "0.5px solid rgba(255,255,255,0.10)" : "0.5px solid rgba(0,0,0,0.08)", boxShadow: theme.palette.mode==="dark" ? "0 8px 24px rgba(0,0,0,0.4)" : "0 8px 24px rgba(0,0,0,0.10)" })}
    >
      <List
        component="nav"
        aria-label="main mailbox folders"
        style={{ minWidth: 300 }}
      >
        {isArray(announcements) &&
          announcements.map((item, key) => (
            <ListItem
              key={key}
              style={{
                border: theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.08)" : "1px solid #eee",
                borderLeft: borderPriority(item.priority),
                cursor: "pointer",
              }}
              onClick={() => handleShowAnnouncementDialog(item)}
            >
              {item.mediaPath && (
                <ListItemAvatar>
                  <Avatar
                    src={item.mediaPath}
                  />
                </ListItemAvatar>
              )}
              <ListItemText
                primary={item.title}
                secondary={
                  <>
                    <Typography component="span" style={{ fontSize: 12 }}>
                      {moment(item.createdAt).format("DD/MM/YYYY")}
                    </Typography>
                    <span style={{ marginTop: 5, display: "block" }}></span>
                    <Typography component="span" variant="body2">
                      {item.text}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))}
        {isArray(announcements) && announcements.length === 0 && (
          <Box sx={{
            display: "flex", flexDirection: "column", alignItems: "center",
            justifyContent: "center", py: "28px", px: "16px", gap: "8px",
          }}>
            <Box sx={{
              width: 36, height: 36, borderRadius: "10px",
              background: theme.palette.mode === "dark" ? "rgba(3,153,255,0.12)" : "#eff6ff",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <CampaignOutlinedIcon sx={{ fontSize: 18, color: "#0399FF" }} />
            </Box>
            <Typography sx={{ fontSize: 12, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.text.primary : "rgba(0,0,0,0.55)" }}>
              Sin anuncios
            </Typography>
            <Typography sx={{ fontSize: 11, color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "rgba(0,0,0,0.35)", textAlign: "center" }}>
              Los comunicados aparecerán aquí
            </Typography>
          </Box>
        )}
      </List>
    </Paper>
  );

  return (
    <div>
      <AnnouncementDialog
        announcement={announcement}
        open={showAnnouncementDialog}
        handleClose={() => setShowAnnouncementDialog(false)}
      />
      <IconButton
        variant="contained"
        aria-describedby={id}
        onClick={handleClick}
        sx={{ color: (theme) => theme.palette.mode === "dark" ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)" }}
      >
        <Badge
          variant="dot"
          invisible={invisible || announcements.length < 1}
          sx={{
            "& .MuiBadge-dot": {
              backgroundColor: "#fbbf24",
              animation: (invisible || announcements.length < 1) ? "none" : "dotPulse 2s cubic-bezier(0.16,1,0.3,1) infinite",
            },
            "@keyframes dotPulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.5 } },
          }}
        >
          <CampaignOutlinedIcon />
        </Badge>
      </IconButton>

      {isMobileLayout ? (
        <ResponsiveSheet open={open} onClose={handleClose}>
          {announcementListContent}
        </ResponsiveSheet>
      ) : (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {announcementListContent}
        </Popover>
      )}
    </div>
  );
}